import React, { useState, useRef } from 'react';
import { Modal, Form, ProgressBar } from 'react-bootstrap';
import { Tabs, Tab, Box, CircularProgress } from '@mui/material';
import SbCancelBtn, { SBSaveUpdateBtn, SDownloadBtn } from '../../Buttons/Buttons';
import xlsImg from '../../../assets/images/UserManagement/xls-img.svg';
import { ADDED_BY_ID } from '../../../Constants';
import * as HeaderAuthentication from '../../HeaderAuthentication';
import { loadBulkUploadTemplates, postDesignationBulkDatas, postDynamicDashboardBulkDatas, postUserManagementBulkDatas } from '../../../redux/action';
import { useDispatch } from 'react-redux';
import attachment from '../../../assets/images/Dashboard/attachment-download-img.svg';

const DynamicDashboardBulkUploadModal = ({ showBulkUploadModal, handleCloseBulkUploadModal, fetchDynamicDashboards }) => {
    const dispatch = useDispatch();

    const [tabValue, setTabValue] = useState(0);
    const [droppedFile, setDroppedFile] = useState(null);
    const [progress, setProgress] = useState(0);
    const [uploadComplete, setUploadComplete] = useState(false);
    const fileInputRef = useRef(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isDownloadComplete, setIsDownloadComplete] = useState(false);
    const [bulkUploadErrorMessage, setBulkUploadErrorMessage] = useState("");
    const [bulkUploadErrorFilePath, setBulkUploadErrorFilePath] = useState(null);
    const [hasDownloaded, setHasDownloaded] = useState(false);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file) {
            setDroppedFile(file);
            simulateUpload(file);
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setDroppedFile(file);
            simulateUpload(file);
        }
    };

    const simulateUpload = (file) => {
        setProgress(0);
        setUploadComplete(false);
        let progressValue = 0;
        const interval = setInterval(() => {
            progressValue += 10;
            setProgress(progressValue);
            if (progressValue >= 100) {
                clearInterval(interval);
                setUploadComplete(true);
            }
        }, 300);
    };

    const AddDepartmentBulkData = (e) => {
        e.preventDefault();
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CompanyID = null;
        const user = signInDetails[0];
        if (user?.SignInType === "SuperAdmin") {
            CompanyID = user.CompanyID;
        } else if (user?.SignInType === "ClientAdmin") {
            CompanyID = user.CompanyID;
        } else if (user?.SignInType === "User") {
            CompanyID = user.CompanyID;
        }

        const formData = new FormData();
        formData.append('File', droppedFile); // Append the actual file object, NOT name
        formData.append('CompanyID', CompanyID);
        formData.append('AddedByID', ADDED_BY_ID);

        const requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.excomatixBulkAuth,
            body: formData,
        };

        dispatch(postDynamicDashboardBulkDatas(requestOption, handleCloseBulkUploadModal, fetchDynamicDashboards, setBulkUploadErrorMessage, setBulkUploadErrorFilePath));
        // console.log([...formData.entries()], 'FormData Content');
    };

    const handleDownloadTemplate = () => {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CompanyID = null;
        const user = signInDetails[0];
        if (user?.SignInType === "SuperAdmin") {
            CompanyID = user.CompanyID;
        } else if (user?.SignInType === "ClientAdmin") {
            CompanyID = user.CompanyID;
        } else if (user?.SignInType === "User") {
            CompanyID = user.CompanyID;
        }
        const fileName = "Dashboard_BulkUpload_Template.xlsx"
        const requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify({ TemplateID: 9, CompanyID: CompanyID }),
        };
        dispatch(loadBulkUploadTemplates(requestOption, setIsDownloading, setIsDownloadComplete, fileName));
    };

    const downloadFile = (fileUrl) => {
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = fileUrl.split("/").pop(); // extract filename from URL
        document.body.appendChild(a);
        a.click();
        a.remove();

        // ✅ Reset so that button changes to Re-Browse
        setDroppedFile(null);
        setProgress(0);
        setUploadComplete(false);
        setBulkUploadErrorMessage("");
        setBulkUploadErrorFilePath(null);
        setHasDownloaded(true);
    };

    return (
        <Modal
            show={showBulkUploadModal}
            onHide={handleCloseBulkUploadModal}
            centered
            size="lg"
            onDrop={handleDrop}
            onDragOver={(e) => e.preventDefault()}
            className="add-customer-modal add-user-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>Bulk Upload</Modal.Title>
            </Modal.Header>

            <Modal.Body style={{ height: "420px" }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={tabValue} onChange={handleTabChange} aria-label="bulk upload tabs">
                        <Tab label="Bulk Upload" />
                        <Tab label="Download Templates" />
                    </Tabs>
                </Box>

                {tabValue === 0 && (
                    <Box sx={{ pt: 3 }}>
                        <Form.Group controlId="bulkFileInput">
                            <div className="drag-and-drop-area" onDrop={handleDrop}>
                                <div className="drag-drop-container">
                                    {droppedFile ? (
                                        <>
                                            <div className="file-info mb-2">
                                                <span>{droppedFile.name}</span>
                                            </div>
                                            <ProgressBar
                                                now={progress}
                                                label={`${progress}%`}
                                                className={`custom-progress ${uploadComplete ? 'complete' : 'incomplete'}`}
                                            />
                                            <div className="d-flex justify-content-between align-items-center pt-2">
                                                <p>({(droppedFile.size / (1024 * 1024)).toFixed(2)} MB)</p>
                                                <p style={{ color: uploadComplete ? 'rgba(58, 201, 119, 1)' : 'rgba(255, 222, 222, 1)' }}>
                                                    {uploadComplete ? 'Completed' : 'Uploading...'}
                                                </p>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="drag-drop-div text-center">
                                            <img src={xlsImg} alt="xls" className="xls-Img" />
                                            <p className="mt-2">Drag & Drop Excel File</p>
                                        </div>
                                    )}
                                    <div className='d-flex g-5'>
                                        {bulkUploadErrorMessage && <div className="text-danger pt-2 fs-6">{bulkUploadErrorMessage}</div>}
                                        {bulkUploadErrorMessage && bulkUploadErrorFilePath && <img src={attachment} alt="" className="download-image" style={{ cursor: 'pointer' }}
                                            onClick={() => downloadFile(bulkUploadErrorFilePath)}
                                        />}
                                    </div>
                                </div>

                                <div className="browse-btn-div mt-3">
                                    {!droppedFile && (
                                        <>
                                            <SBSaveUpdateBtn
                                                // btnName="Browse Files" 
                                                btnName={hasDownloaded ? "Re-Browse Files" : "Browse Files"}
                                                onClickEffect={() => fileInputRef.current.click()}
                                            />
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                style={{ display: 'none' }}
                                                onChange={handleFileChange}
                                            />
                                        </>
                                    )}
                                </div>
                            </div>
                        </Form.Group>
                    </Box>
                )}

                {tabValue === 1 && (
                    <Box sx={{ pt: 3 }} className="drag-and-drop-area">
                        <div className="text-center mt-3 drag-drop-container" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "210px", flexDirection: "column" }}>
                            <SDownloadBtn btnName="Download Templates" onClickEffect={handleDownloadTemplate} />
                            {isDownloading && (
                                <div style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "8px" }}>
                                    <CircularProgress size={24} />
                                    <span>Downloading...</span>
                                </div>
                            )}

                            {isDownloadComplete && (
                                <div style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "8px", color: "#3AC977" }}>
                                    <span>✅ Download Completed!</span>
                                </div>
                            )}
                        </div>
                    </Box>
                )}
            </Modal.Body>

            {droppedFile && tabValue === 0 && (
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={handleCloseBulkUploadModal} />
                    {/* ✅ Show Submit button only if upload completed */}
                    {uploadComplete && (<SBSaveUpdateBtn btnName="Submit" onClickEffect={AddDepartmentBulkData} />)}
                </Modal.Footer>
            )}
        </Modal>
    );
};

export default DynamicDashboardBulkUploadModal;
